import React from "react";
import TextLogo from '../assets/text-logo.png';

function Loader(props) {
  return (
    <div className="App container_12">
      <section id="main">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "90vh",
            flexDirection: "column",
          }}
        >
          <img src="images/logo.png" alt="logo" width={132} height={56} />
          <h2 id="site_description">Powered by your Trust</h2>
          <img src={TextLogo} width="15%" height="auto" alt="text-logo" />
          <p>Please wait. Loading..</p>
        </div>
      </section>
    </div>
  );
}

export default Loader;
